import styled, { css } from 'styled-components';
import type { Theme } from '@/styles/theme';

export type BannerIntent = 'info' | 'success' | 'warning' | 'danger';

const intentColors = (theme: Theme, intent: BannerIntent) => {
  switch (intent) {
    case 'success':
      return { bg: theme.colors.successBg, border: theme.colors.successBorder, fg: theme.colors.successText, glyph: theme.colors.success };
    case 'warning':
      return { bg: theme.colors.warningBg, border: theme.colors.warningBorder, fg: theme.colors.warningText, glyph: theme.colors.warning };
    case 'danger':
      return { bg: theme.colors.dangerBg, border: theme.colors.dangerBorder, fg: theme.colors.dangerText, glyph: theme.colors.danger };
    case 'info':
    default:
      return { bg: theme.colors.primary50, border: theme.colors.primary200, fg: theme.colors.primary, glyph: theme.colors.info };
  }
};

export const BannerRoot = styled.div<{ $intent: BannerIntent }>`
  ${({ $intent, theme }) => {
    const c = intentColors(theme, $intent);
    return css`
      background: ${c.bg};
      border: 1px solid ${c.border};
      color: ${c.fg};
    `;
  }}
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  border-radius: ${({ theme }) => theme.radii.lg};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.normal};
`;

export const BannerGlyph = styled.span<{ $intent: BannerIntent }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  color: ${({ $intent, theme }) => intentColors(theme, $intent).glyph};
`;

export const BannerBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BannerTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;
